/* Product Carousel component (components/product-carousel.php): slick init.
   Call tmProductCarousel.init(scope) after inserting a carousel via AJAX. */
window.tmProductCarousel = {
    init: function (scope) {
        jQuery(scope || document).find('.c-product-carousel__slider:not(.slick-initialized):not([data-layout="grid"])').each(function () {
            let $slider = jQuery(this);
            let slides = parseInt($slider.attr('data-slides')) || 4;
            let slidesTablet = parseInt($slider.attr('data-slides-tablet')) || 3;
            let slidesMobile = parseInt($slider.attr('data-slides-mobile')) || 2;
            let loop = parseInt($slider.attr('data-loop')) === 1;
            // nav = header: the "1 / 3" counter + round arrows in the title row (components/product-carousel.php), and
            // with nav_below their copy under the cards (1024px and down): slick takes both as its arrows, the counter both
            let $controls = $slider.closest('.c-product-carousel--nav-header').find('.slider__controls');
            let $pageStatus = $controls.find('.page__status');
            if ($pageStatus.length) {
                // bound once: init runs again on this slider when it re-slicks after the phone-width "unslick" (resize, below)
                $slider.off('.tmCarouselCounter').on('init.tmCarouselCounter afterChange.tmCarouselCounter', function (event, slick, currentSlide) {
                    let step = slick.options.slidesToScroll || 1;
                    $pageStatus.text((Math.floor((currentSlide || 0) / step) + 1) + ' / ' + Math.max(1, Math.ceil(slick.slideCount / step)));
                });
            }

            $slider.slick({
                dots: false,
                infinite: loop,
                speed: 300,
                slidesToShow: slides,
                slidesToScroll: slides,
                arrows: true,
                touchThreshold: 20,
                prevArrow: $controls.length ? $controls.find('.previous__arrow') : '<button type="button" class="slick-prev c-btn c-btn-circle c-btn-shadow" aria-label="Previous"><i class="fa-regular fa-chevron-left"></i></button>',
                nextArrow: $controls.length ? $controls.find('.next__arrow') : '<button type="button" class="slick-next c-btn c-btn-circle c-btn-shadow" aria-label="Next"><i class="fa-regular fa-chevron-right"></i></button>',
                responsive: [
                    { breakpoint: 1025, settings: { slidesToShow: slidesTablet, slidesToScroll: slidesTablet } },
                    { breakpoint: 600, settings: { slidesToShow: slidesMobile, slidesToScroll: slidesMobile } },
                    { breakpoint: 505, settings: 'unslick' }
                ]
            });

            // below 505px slick is off ("unslick") and the row is a native scroller: the arrows (nav_below's; the
            // header's are hidden there) step it one card at a time and the counter follows its scroll position, card /
            // cards (Peter, COOL 95, r26a: "under cards, all phones"); greyed at either end as slick greys them. Bound
            // once per carousel; from 505px slick's own handlers drive them and these stand aside
            if ($controls.length && !$slider.data('tmNativeNav')) {
                $slider.data('tmNativeNav', true);
                let slider = this;
                let $prev = $controls.find('.previous__arrow');
                let $next = $controls.find('.next__arrow');
                let isNative = function () {
                    return !$slider.hasClass('slick-initialized');
                };
                let cardStep = function () {
                    let slides = slider.querySelectorAll('.c-product-carousel__slide');
                    return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slider.clientWidth;
                };
                let sync = function () {
                    if (!isNative()) {
                        return;
                    }
                    let count = slider.querySelectorAll('.c-product-carousel__slide').length;
                    // a section panel not shown (hidden) has no width and its cards no step: it opens at its first card
                    // (0 / 0 read "NaN / 12" once its chip showed it; Peter, COOL 127, r43j)
                    let step = cardStep();
                    let atEnd = slider.clientWidth > 0 ? slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 2 : count <= 1;
                    $pageStatus.text((atEnd ? count : (step > 0 ? Math.round(slider.scrollLeft / step) : 0) + 1) + ' / ' + count);
                    $prev.toggleClass('slick-disabled', slider.scrollLeft <= 2);
                    $next.toggleClass('slick-disabled', atEnd);
                };
                $prev.on('click.tmNativeNav', function () {
                    if (isNative()) {
                        slider.scrollBy({left: -cardStep(), behavior: 'smooth'});
                    }
                });
                $next.on('click.tmNativeNav', function () {
                    if (isNative()) {
                        slider.scrollBy({left: cardStep(), behavior: 'smooth'});
                    }
                });
                slider.addEventListener('scroll', sync, {passive: true});
                // the row gets its width (its section chip shows a hidden panel): count it again, arrows too
                if (window.ResizeObserver) {
                    new ResizeObserver(sync).observe(slider);
                }
                $slider.on('destroy', function () { // slick unslicked on a resize below 505px
                    setTimeout(sync, 0);
                });
                sync();
            }

            // image_slider (components/product-carousel.php): the cards' photo slider, here too for AJAX inserts
            if ($slider.is('[data-image-slider]') && window.tmProductCardSlider) {
                window.tmProductCardSlider.init(this);
            }
        });
    }
};

// The whole card opens the product (both layouts), like the theme's .product-list grids (custom.js binds that to
// .product-list .product-card, which the component does not have). Links, buttons and the wishlist heart keep
// their own behaviour; the card's first link supplies the URL and target (the wishlist grid opens a new tab).
// Safe under slick: a drag longer than 10px sets shouldClick = false and slick stops the click at .slick-list,
// so it never reaches this document handler.
jQuery(document).on('click', '.c-product-carousel .product-card', function (e) {
    if (jQuery(e.target).closest('a, button, .favorite-icon').length) {
        // (the card photo slider's arrows and dots are <button>s — product-card-slider.js)
        return;
    }
    const link = this.querySelector('a[href]');
    if (!link) {
        return;
    }
    const target = link.getAttribute('target');
    if (target && target !== '_self') {
        window.open(link.href, target);
    } else {
        window.location = link.href;
    }
});

jQuery(function () {
    tmProductCarousel.init();

    // slick's "unslick" breakpoint (< 505px) removes its own resize listener, so a carousel shrunk to phone
    // width never re-slicks when the window grows again (cards stayed stacked full width). Re-init on a real
    // width change, like highlight-cards.js / comparison-table.js; iOS URL-bar resizes only change the height.
    let lastWidth = jQuery(window).width();
    let resizeTimer;
    jQuery(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            let width = jQuery(window).width();
            if (width === lastWidth) {
                return;
            }
            lastWidth = width;
            if (width >= 505) {
                tmProductCarousel.init();
            }
            // a page loaded below 1025px never set up the image_slider rows' card photo sliders (their dots show
            // once widened); the card slider checks the breakpoint itself and skips the ones already set up
            if (window.tmProductCardSlider) {
                jQuery('.c-product-carousel__slider[data-image-slider]').each(function () {
                    window.tmProductCardSlider.init(this);
                });
            }
        }, 200);
    });
});
